import { makeStyles } from '@material-ui/core/styles';
import { isIOS } from 'react-device-detect';

export default makeStyles((theme) => ({
  container: {
    alignItems: 'center',
    background: theme.palette.common.white,
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    margin: 0,
    maxHeight: '100%',
    maxWidth: '100%',
    minHeight: isIOS ? '-webkit-fill-available' : '100vh',
  },
  dialogContainer: {
    borderRadius: '30px',
    height: 'fit-content',
    width: '350px',
  },
  header: {
    background: theme.palette.common.white,
  },
}));
